import * as React from 'react';
import { styled } from '@mui/material/styles';
import {Accordion, AccordionSummary, AccordionDetails, Typography} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PurpleButton from '../common/buttonTheme';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

export default function NotesPresenter({notes,onNotesChange}) {

    const [open, setOpen] = React.useState(false);
    const [title, setTitle] = React.useState("");
    const [note, setNote] = React.useState("");
    const [createdDate, setcreatedDate] = React.useState(null);
    const [editIndex, setEditIndex] = React.useState(-1);
    const [confirmDeleteOpen, setConfirmDeleteOpen] = React.useState(false);

    const handleClickOpenNew = () => {
        setOpen(true);
    };

    const handleClickOpenEdit = (index) => {
        setTitle(notes[index].title);
        setNote(notes[index].note);
        if(index > -1) {
            setcreatedDate(notes[index].createdDate)
        }    
        setEditIndex(index);
        setOpen(true);
    };

    const handleClickDelete = (index) => {
        setConfirmDeleteOpen(true);
    };
    
    const handleCloseDeleteDialogue = () => {
        setConfirmDeleteOpen(false);
        setBlankValues();
    };

    const actionDelete = () => {
        onNotesChange(editIndex, {title: "", note: ""}, true);
        setConfirmDeleteOpen(false);
    }

    const handleSave = () => {
        if (editIndex > -1) { 
            onNotesChange(editIndex, {title: title, note: note, createdDate: createdDate}, false);
        }
        else {
            onNotesChange(-1, {title: title, note: note}, false);
        }     
        setOpen(false);
        setBlankValues();
      };
    

    const handleClose = () => {
      setOpen(false);
      setBlankValues();
    };

    const setBlankValues = () => {
        setTitle("");
        setNote("");
        setcreatedDate(null);
        setEditIndex(-1)
        setConfirmDeleteOpen(false);
    }
    
  return (

    <div>
    <Paper elevation={3} style={{padding: 8}}>
    <Typography variant="h6" display="block" gutterBottom>Notes</Typography>
    <Stack sx={{ width: '100%' }} spacing={2}>
        <Alert severity="warning">Note, when adding , changing or removing notes ensure you click "SAVE TODO" to save your changes"</Alert>    
    </Stack>
    <PurpleButton size="large" variant="contained" onClick={()=>{handleClickOpenNew()}}>Add note</PurpleButton>
    <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add Note</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="title"
            label="Title"
            fullWidth
            variant="standard"
            value={title}
            onChange={(e)=>{setTitle(e.target.value)}}/>

            <TextField
                autoFocus
                margin="dense"
                id="name"
                label="Note"
                fullWidth
                variant="standard"
                multiline
                value={note}
                inputProps={{ style: { resize: "both" } }}
                onChange={(e)=>{setNote(e.target.value)}}
            />

        </DialogContent>
        <DialogActions>
            <PurpleButton onClick={handleClose} variant="contained">Cancel</PurpleButton>  
            <PurpleButton onClick={handleSave} variant="contained">Save</PurpleButton>
        </DialogActions>
    </Dialog>

    <Dialog open={confirmDeleteOpen} onClose={handleCloseDeleteDialogue}>
        <DialogTitle>Are you sure you want to remove this note?</DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions>
            <PurpleButton onClick={()=>{actionDelete()}} variant="contained">Yes</PurpleButton>
            <PurpleButton onClick={() =>{handleCloseDeleteDialogue()}} variant="contained">No</PurpleButton>
        </DialogActions>
    </Dialog>    

      {notes.map((note, index) => {
        return ( 
        <Accordion key={`acc_${index}`}>
            <AccordionSummary
                key={`accsumm_${index}`}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header">
                <Typography>{note.title}</Typography>
            </AccordionSummary>
            <AccordionDetails key={`accdet_${index}`}>
                <Typography style={{whiteSpace: "pre-line"}}>
                    {note.note}
                </Typography>
                <PurpleButton onClick={()=>{handleClickOpenEdit(index);}} variant="contained">Edit</PurpleButton>
                <PurpleButton onClick={()=>{handleClickDelete(index);}} variant="contained">Remove</PurpleButton>
            </AccordionDetails>
      </Accordion>)
      })}
    </Paper>
    </div>
  );
}